import config from "config";

const Variables = config;

export default Variables;